import {startsWith} from 'lodash';

export default function resolveGaiaURL(types: {[key: string]: LayerType}, url: string) {
    if (!startsWith(url, 'g://')) return url;
    return types[url.split('/')[2]].tileUrl;
}
